import * as TranscriptService from "../../services/transcript.service";

export const SET_TRASH_LOADING = 'SET_TRASH_LOADING';
export const SET_TRASH_DATA = 'SET_TRASH_DATA';
export const SET_TRASH_PAGINATION_INFO = 'SET_TRASH_PAGINATION_INFO';
export const RESET_TRASH_STATE = 'RESET_TRASH_STATE';

export const getTrashData = () => async (dispatch, getState) => {
  const paginationInfo = getState().trashReducer.paginationInfo;

  let sort = paginationInfo.sortDirection === 'asc' ? paginationInfo.sortKey : `-${paginationInfo.sortKey}`;
  const queryParams = {
    page: paginationInfo.currentPage,
    per_page: paginationInfo.perPage,
    sort: sort
  };

  dispatch(setLoading(true));

  try {
    const res = await TranscriptService.getTrashItems(queryParams);
    dispatch(setTrashData(res.data.data));
    dispatch(setLoading(false));
    if (res.data._metadata) {
      dispatch(setPaginationInfo({...paginationInfo, totalCount: res.data._metadata.total_count}));
    }
  } catch (e) {
    dispatch(setLoading(false));
    throw (e);
  }
};

export const setTrashData = (value) => ({
  type: SET_TRASH_DATA,
  payload: { trashData: value }
});

export const setLoading = (value) => ({
  type: SET_TRASH_LOADING,
  payload: value
});

export const setPaginationInfo = (value) => ({
  type: SET_TRASH_PAGINATION_INFO,
  payload: { paginationInfo: value }
});

export const emptyTrash = () => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    const res = await TranscriptService.emptyTrash();
    if (res.status === 204) {
      dispatch(resetState());
    }

  } catch (e) {
    dispatch(setLoading(false));
    throw (e);
  }
};

export const restoreTranscript = (id) => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    await TranscriptService.restoreTranscript(id);
    dispatch(getTrashData());

  } catch (e) {
    dispatch(setLoading(false));
    throw (e);
  }
};

export const deleteTranscriptForever = (id) => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    const res = await TranscriptService.deleteTranscriptForever(id);
    if (res.status === 204) {
      dispatch(getTrashData());
    }

  } catch (e) {
    dispatch(setLoading(false));
    throw (e);
  }
};

export const resetState = () => ({
  type: RESET_TRASH_STATE
});
